import { useMemo } from 'react'
import config from 'constants/config'

/**
 * Hook to get Maldives charter priority support contact information
 * Returns priority contact for AU region when charter flight is in checkout
 *
 * @param currentRegionCode - The current region code (e.g., 'AU')
 * @param isCharterFlightCheckout - Whether the checkout contains a charter flight
 * @returns Priority contact information or undefined
 */
export function useMaldivesCharterContact(
  currentRegionCode: string | undefined,
  isCharterFlightCheckout: boolean | undefined,
): App.GeoContact | undefined {
  return useMemo(() => {
    const showMaldivesCharterPrioritySupportNumber =
      (currentRegionCode === 'AU' || (config.agentHub.isEnabled && currentRegionCode === 'NZ')) &&
      isCharterFlightCheckout &&
      !!config.MALDIVES_CHARTER_PRIORITY_SUPPORT_NUMBER

    if (!showMaldivesCharterPrioritySupportNumber) return undefined

    return {
      humanReadable: config.MALDIVES_CHARTER_PRIORITY_SUPPORT_NUMBER,
      number: config.MALDIVES_CHARTER_PRIORITY_SUPPORT_NUMBER?.replace(/\s+/g, ''),
    }
  }, [currentRegionCode, isCharterFlightCheckout])
}
